import { render, staticRenderFns } from "./SaleItemsWithGroupByUsername.vue?vue&type=template&id=bbcf540c&scoped=true"
import script from "./SaleItemsWithGroupByUsername.vue?vue&type=script&lang=js"
export * from "./SaleItemsWithGroupByUsername.vue?vue&type=script&lang=js"
import style0 from "./SaleItemsWithGroupByUsername.vue?vue&type=style&index=0&id=bbcf540c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf540c",
  null
  
)

export default component.exports